import { Injectable } from '@angular/core';
import { CookieStorage } from "../cookie-storage.model";
import { NotificationService } from "./notification.service";

@Injectable()
export class StorageService {
    private storage: any;

    constructor(private notificationService: NotificationService) {
        this.getStorageType();
    }

    private getStorageType() {
        if (this.storage)
            return;
        try {
            localStorage.setItem('test', new Date().toString());
            this.storage = localStorage;
        }
        catch (e) {
            this.notificationService.showWarning("Please enable localstorage so the app can run properly!");
            if (navigator.cookieEnabled) {
                this.storage = new CookieStorage();
            } else {
                var MemoryStorage = require('memorystorage');
                this.storage = new MemoryStorage('samba-app');
            }
        }
    }

    public get<T>(key: string) {
        let value = this.storage.getItem(key);
        if (value === null) { return null; }
        return <T>JSON.parse(value);
    }

    public set<T>(key: string, value: T) {
        this.storage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string) {
        this.storage.removeItem(key);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/storage.service.ts